import { Transfer } from 'antd';
import { RecordType, SharedTransferProps } from 'src/models/EditProject';
import { TransferItem } from './TransferItem';

const SharedTransfer: React.FC<SharedTransferProps> = ({
  dataSource,
  targetKeys,
  selectedKeys,
  onChange,
  onSelectChange,
  onScroll,
  onSearch,
  filterOption,
  disabled = false,
  titles = ['Source', 'Target'],
  showSearch = false,
  style,
  lastMovedKeys = [],
  loading = false,
}) => {
  const renderItem = (item: RecordType) => ({
    label: (
      <TransferItem
        title={item.title}
        isNewlyMoved={lastMovedKeys.includes(item.key)}
      />
    ),
    value: item.title,
  });

  return (
    <Transfer
      dataSource={dataSource}
      titles={titles}
      targetKeys={targetKeys}
      selectedKeys={selectedKeys}
      onChange={onChange}
      onSelectChange={onSelectChange}
      onScroll={onScroll}
      onSearch={onSearch}
      filterOption={filterOption}
      disabled={disabled}
      showSearch={showSearch}
      oneWay={false}
      style={{ width: '100%', height: 500 }}
      showSelectAll={false}
      render={renderItem}
    />
  );
};

export default SharedTransfer;
